module.exports = __webpack_public_path__ + "img/icon_attend.c03412c6.png";